import InsuredService from '@/services-http/contract/InsuredService';
import BeneficiaryContractedPlanService from '@/services-http/contract/BeneficiaryContractedPlanService';
import DependentContractedPlanService from '@/services-http/contract/DependentContractedPlanService';
import ReuseFamilyGroupInclusionMixin from './ReuseFamilyGroupInclusionMixin';
import MovementRecordService from '@/services-http/sdi/MovementRecordService';
import moment from 'moment';

export default {
  name: "ReuseMovementMixin",
  mixins: [
    ReuseFamilyGroupInclusionMixin,
  ],
  methods: {
    getReuseMovementRecord() {
      return JSON.parse(sessionStorage.getItem('movementRecord'));
    },
    async getHolderAttachmentsToReuse(movement) {
      switch(movement.movementType) {
        case "INSERT":
          return await this.getHolderAttachments(movement);
        case "UPDATE":
          return await this.getHolderAttachments(movement);
      }

    },
    async fetchBeneficiaryContractIds(movement) {
      const beneficiaryBenefits = await this.fetchBeneficiaryBenefits(movement);
      return beneficiaryBenefits.map((beneficiary) => Number(beneficiary.contractId));
    },
    async fetchBeneficiarySubContractIds(movement) {
      const beneficiaryBenefits = await this.fetchBeneficiaryBenefits(movement);
      return beneficiaryBenefits.map((beneficiary) => Number(beneficiary.subContractId));
    },
    async fetchBeneficiaryEligibityIds(movement) {
      const bcpService = new BeneficiaryContractedPlanService();
      const dcpService = new DependentContractedPlanService();

      const beneficiaryBenefits = await this.fetchBeneficiaryBenefits(movement);

      const eligibilityIds = [];

      for (const beneficiaryBenefit of beneficiaryBenefits) {
        if (!movement.movementType.includes("DEPENDENT")) {
          await bcpService.FindInsuredByBeneficiaryContractedPlanId(beneficiaryBenefit.contractedPlanId)
            .then((response) => response.data)
            .then((contractedPlan) => {
              if (contractedPlan && Object.keys(contractedPlan).length > 0) {
                eligibilityIds.push(contractedPlan.eligibilityId)
              }
            })
        } else {
          await dcpService.FindInsuredByDependentContractedPlanId(beneficiaryBenefit.contractedPlanId)
            .then((response) => response.data)
            .then((contractedPlan) => {
              if (contractedPlan && Object.keys(contractedPlan).length > 0) {
                eligibilityIds.push(contractedPlan.eligibilityId)
              }
            })
        }
      }

      return eligibilityIds
    },
    async fetchBeneficiaryPlans(movement, contractId, subContractId) {
      const beneficiaryBenefits = await this.fetchBeneficiaryBenefits(movement);
      const benefitContracts = beneficiaryBenefits.filter((benefit) => benefit.contractId === contractId && benefit.subContractId === subContractId);
      return benefitContracts.map((beneficiary) => Number(beneficiary.planId));
    },
    async fetchBeneficiaryContractedPlanByParams(movement, contractId, subContractId) {
      const bcpRequest = this.fetchBcpRequest(movement);

      const beneficiaryBenefits = await this.fetchBeneficiaryBenefits(movement);
      const benefit = beneficiaryBenefits.find((benefit) => benefit.contractId === contractId && benefit.subContractId === subContractId);
      const beneficiaryContractResult = await bcpRequest(benefit.contractedPlanId);
      const contractPlanId = beneficiaryContractResult && beneficiaryContractResult.contractPlanId
        ? beneficiaryContractResult.contractPlanId
        : null;

      const parentContractPlanId = beneficiaryContractResult && beneficiaryContractResult.parentContractPlanId
        ? beneficiaryContractResult.parentContractPlanId
        : null;

      const contractPolicy = beneficiaryContractResult && beneficiaryContractResult.contractPolicy
        ? beneficiaryContractResult.contractPolicy
        : null;

      const contractMember = beneficiaryContractResult && beneficiaryContractResult.memberId
        ? beneficiaryContractResult.memberId
        : null;

      const subContractNumber = beneficiaryContractResult && beneficiaryContractResult.subcontractNumber
        ? beneficiaryContractResult.subcontractNumber
        : null;

      return {
        contractPlanId: contractPlanId,
        parentContractPlanId: parentContractPlanId,
        contractPolicy: contractPolicy,
        memberId: contractMember,
        subContractNumber: subContractNumber,
      };
    },
    async getDependentsAttachmentsToReuse(movement) {
      switch(movement.movementType) {
        case "INSERT":
          return await this.getDependentAttachments(movement);
        case "INSERT_DEPENDENT":
          return await this.getDependentAttachments(movement);
        case "UPDATE_DEPENDENT":
          return await this.getDependentAttachments(movement);
      }
    },
    hasPermissionToReuseMovement(movement) {
      return !this.isRhProtegidoQuery && this.reuseMovementStatusPermission(movement);
    },
    async fetchBeneficiaryMovements(movement) {
      const movementRecordService = new MovementRecordService();
      const params = new URLSearchParams();
      params.append('document', movement.insuredDocumentNumber);
      params.append('movementType', movement.movementType);
      return await movementRecordService.FindByParams(params)
        .then((response) => response.data)
        .then((result) => result.content);
    },
    async fetchBeneficiaryBenefits(movement) {
      const insuredService = new InsuredService();
      const params = new URLSearchParams();
      params.append('cpf', movement.insuredDocumentNumber);
      params.append('insuredSituation', "ACTIVE");
      return await insuredService.FindAllByFilters(params)
        .then((response) => response.data)
        .then((result) => result.content);
    },
    reuseMovementStatusPermission(movement) {
      const movBeneficaryIntegrationStatus = movement.beneficaryIntegrationStatus;
      const isReleasedStatus = ['VALID', 'ELIGIBLE', 'ADJUSTED'].some((status) => status === movement.status, false);
      const isFinishedSuccessfully = movement.status === 'SUCCESS' && movBeneficaryIntegrationStatus === 'INTEGRATION_COMPLETED';
      const isFinishedInCarrier = movement.status === 'SUCCESS' && (movBeneficaryIntegrationStatus !== 'INTEGRATION_COMPLETED' || movBeneficaryIntegrationStatus === null);
      const isWaitSubmission = movement.status === 'WAIT_SUBMISSION';
      const isSubmitted = movement.status === 'SUBMITTED';
      return [isReleasedStatus, isWaitSubmission, isSubmitted, isFinishedSuccessfully, isFinishedInCarrier].some((rule) => !!rule);
    },

    async fetchBeneficiaryBenefit(movement, contractId) {
      const bcpRequest = this.fetchBcpRequest(movement)

      const beneficiaryBenefits = await this.fetchBeneficiaryBenefits(movement);
      const benefits = beneficiaryBenefits.filter((benefit) => benefit.contractId === contractId);
      const contractedPlanIds = benefits.map((benefit) => benefit.contractedPlanId)
      const promiseContractedPlans = contractedPlanIds.map((contractedPlanId) => bcpRequest(contractedPlanId))
      const activeBenefits = await Promise.all(promiseContractedPlans)
      const mappedBenefits = activeBenefits.map((benefit) => ({
        contractId: benefit.contractId ? Number(benefit.contractId) : null,
        subcontractId: benefit.subcontractId ? Number(benefit.subcontractId) : null,
        eligibilityId: benefit.eligibilityId ? Number(benefit.eligibilityId) : null,
        planId: benefit.planId ? Number(benefit.planId) : null,
        validityDate: benefit.contractStartDate ? moment(benefit.contractStartDate, "YYYY-MM-DD").format("DD/MM/YYYY") : null
      }));

      return mappedBenefits;
    },

    fetchBcpRequest(movement) {
      const bcpService = movement.movementType.includes('DEPENDENT')
        ? new DependentContractedPlanService()
        : new BeneficiaryContractedPlanService();

      return movement.movementType.includes('DEPENDENT')
        ? (contractedPlanId) => bcpService.FindInsuredByDependentContractedPlanId(contractedPlanId).then((response) => response.data).catch((e) => [])
        : (contractedPlanId) => bcpService.FindInsuredByBeneficiaryContractedPlanId(contractedPlanId).then((response) => response.data).catch((e) => []);
    },
  },
  computed: {
    isReuseMovement() {
      const isReuse = JSON.parse(sessionStorage.getItem('isReuse'));
      return !!isReuse;
    },
    isRhProtegidoQuery() {
      return this.$route.query &&
             this.$route.query.isRHProtegido &&
             this.$route.query.isRHProtegido === 'true';
    }
  },
}
